import { apiFetch } from "./client.ts";

export interface ServiceCatalogItem {
  id: string;
  account_id: string;
  site_id: string | null;
  code: string;
  name: string;
  name_he: string | null;
  description: string | null;
  default_duration_minutes: number;
  default_price: string;
  tax_rate_pct: string;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ServiceCatalogList {
  items: ServiceCatalogItem[];
  total: number;
}

export async function listServiceCatalog(params: {
  site_id?: string;
  active_only?: boolean;
} = {}): Promise<ServiceCatalogList> {
  const usp = new URLSearchParams();
  if (params.site_id) usp.set("site_id", params.site_id);
  if (params.active_only) usp.set("active_only", "true");
  return apiFetch<ServiceCatalogList>(`/service-catalog?${usp}`);
}

export async function createServiceCatalogItem(payload: {
  code: string;
  name: string;
  name_he?: string;
  description?: string;
  default_duration_minutes?: number;
  default_price?: number;
  tax_rate_pct?: number;
  site_id?: string;
  active?: boolean;
}): Promise<ServiceCatalogItem> {
  return apiFetch<ServiceCatalogItem>("/service-catalog", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateServiceCatalogItem(
  id: string,
  patch: Partial<ServiceCatalogItem>,
): Promise<ServiceCatalogItem> {
  return apiFetch<ServiceCatalogItem>(`/service-catalog/${id}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export async function deleteServiceCatalogItem(id: string): Promise<void> {
  await apiFetch<void>(`/service-catalog/${id}`, { method: "DELETE" });
}
